import React from "react";
import classNames from "classnames";

import styles from "./Label.module.scss";

interface LabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}

export const Label: React.FC<LabelProps> = ({ htmlFor, children, className = "" }) => {
  return (
    <label htmlFor={htmlFor} className={classNames(styles.label, className)}>
      {children}
    </label>
  );
};
